import { useQuery, useMutation } from '@tanstack/react-query'
import { api, type ReportGenerateParams } from '@/lib/api-client'

/**
 * Fetch available report templates
 */
export function useReportTemplates() {
  return useQuery({
    queryKey: ['report-templates'],
    queryFn: () => api.analytics.reportTemplates(),
    staleTime: 60 * 60 * 1000, // 1 hour - templates don't change often
  })
}

/**
 * Generate a specific report
 */
export function useGenerateReport() {
  return useMutation({
    mutationFn: (params: ReportGenerateParams) => api.analytics.generateReport(params),
  })
}
